import React from "react";
import { Box, Grid } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const chartOptions = {
  title: {
    text: "Order Summary",
    align: "left",
    style: {
      fontFamily: "Lexend",
      fontSize: "24px",
      fontWeight: 500,
    },
  },
  xAxis: {
    categories: ["Nov", "Dec", "Jan", "Feb", "Mar"],
  },
  yAxis: {
    title: { text: null },
    max: 400,
  },
  series: [
    {
      name: "On Hold",
      data: [50, 30, 70, 60, 40],
      color: "#ffca28",
    },
    {
      name: "Completed",
      data: [100, 150, 200, 250, 300],
      color: "#82ca9d",
    },
  ],
  legend: {
    align: "left",
    verticalAlign: "bottom",
    layout: "horizontal",
  },
  chart: {
    height: 400,
  },
};

const OrderSummaryChart = () => {
  return (
    <Grid item xs={12} md={8}>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          padding: 2,
          height: "100%",
        }}
      >
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </Box>
    </Grid>
  );
};

export default OrderSummaryChart;
